import React, { useState } from 'react';

import './Drawer.css';

interface DrawerProps {
    label: string;
    headerRight?: React.ReactNode;
    children: React.ReactNode;
    defaultOpen?: boolean;
}

export function Drawer({ label, headerRight, children, defaultOpen = false }: DrawerProps) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <section className={`pdp-drawer${open ? ' pdp-drawer--open' : ''}`}>
            <button
                type="button"
                className="pdp-drawer__header"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
            >
                <span className="pdp-drawer__label">{label}</span>
                <span className="pdp-drawer__right">
                    {headerRight}
                    <span className="pdp-drawer__toggle">
                        <span className="pdp-drawer__toggle-text">{open ? 'see less' : 'see more'}</span>
                        <span className={`pdp-drawer__toggle-icon${open ? ' pdp-drawer__toggle-icon--open' : ''}`} aria-hidden="true">
                            +
                        </span>
                    </span>
                </span>
            </button>
            {open && <div className="pdp-drawer__body">{children}</div>}
        </section>
    );
}
